import React from 'react'

function Moterializeidea() {
    return (
        <div className='moterializa_main  wow animate__fadeInUp' data-wow-duration="1s">
            <div className='moterialize_card'>
                <div className='moterialize_card_inner'>
                    <div className='moterialize_content_button'>
                        
                        <div className='moterialize_content'>
                            <h2 className='moterializetitle'>Materialize Your Idea</h2>
                            <p className='moterializeparagraph'> Contact us today and discover how our team can maximize your return on investment.</p>
                        </div>
                        <div className='moterialize_button_con'>
                            <a className='moterialize_button' href="/contact">Contact Us</a>
                        </div>
                    </div>
                    <div className='moterialize_gradiant_blur'></div>
                </div>
            </div>
        </div>
    )
}

export default Moterializeidea